import { IPrebidConfiguration } from "@almamedia/amr-adtech-stack/lib/services/prebid/prebid";

const prebid: IPrebidConfiguration = {
  enabled: true,
  defaults: {
    prebidTimeout: 800,
    rubicon: {
      singleRequest: true,
      accountId: "10101",
      siteId: "32466",
    },
    adform: {
      rcur: "USD",
    },
  },
  bids: {
    Iltalehti_Asuminen_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "334462" } },
        { bidder: "adform", params: { mid: "101819" } },
      ],
    },
    Iltalehti_Asuminen_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "348418" } },
        { bidder: "adform", params: { mid: "107508" } },
      ],
    },
    Iltalehti_Asuminen_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "342206" } },
        { bidder: "adform", params: { mid: "105504" } },
      ],
    },
    Iltalehti_Asuminen_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369408" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369132" },
        },
        { bidder: "adform", params: { mid: "116675" } },
        { bidder: "adform", params: { mid: "116840" } },
      ],
    },
    Iltalehti_Asuminen_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651928" },
        },
        { bidder: "adform", params: { mid: "712126" } },
      ],
    },
    Iltalehti_Autot_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "301808" } },
        { bidder: "adform", params: { mid: "92869" } },
      ],
    },
    Iltalehti_Autot_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "342760" } },
        { bidder: "adform", params: { mid: "105666" } },
      ],
    },
    Iltalehti_Autot_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "342758" } },
        { bidder: "adform", params: { mid: "105665" } },
      ],
    },
    Iltalehti_Autot_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369416" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369370" },
        },
        { bidder: "adform", params: { mid: "116799" } },
        { bidder: "adform", params: { mid: "116844" } },
      ],
    },
    Iltalehti_Autot_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651936" },
        },
        { bidder: "adform", params: { mid: "712129" } },
      ],
    },
    Iltalehti_Digi_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "334652" } },
        { bidder: "adform", params: { mid: "101946" } },
      ],
    },
    Iltalehti_Digi_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "154740" } },
        { bidder: "adform", params: { mid: "155834" } },
      ],
    },
    Iltalehti_Digi_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "154738" } },
        { bidder: "adform", params: { mid: "77629" } },
      ],
    },
    Iltalehti_Digi_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369418" },
        },
        { bidder: "adform", params: { mid: "116845" } },
      ],
    },
    Iltalehti_Digi_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651938" },
        },
        { bidder: "adform", params: { mid: "712131" } },
      ],
    },
    Iltalehti_Etusivu_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "547386" } },
        { bidder: "adform", params: { mid: "574131" } },
      ],
    },
    Iltalehti_Etusivu_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "327486" } },
        { bidder: "adform", params: { mid: "79420" } },
      ],
    },
    Iltalehti_Etusivu_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "1483976" } },
        { bidder: "adform", params: { mid: "77630" } },
      ],
    },
    Iltalehti_Etusivu_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "284256" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "323334" },
        },
        { bidder: "adform", params: { mid: "98581" } },
        { bidder: "adform", params: { mid: "81036" } },
      ],
    },
    Iltalehti_Hyvaolo_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "301862" } },
        { bidder: "adform", params: { mid: "92889" } },
      ],
    },
    Iltalehti_Hyvaolo_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "154728" } },
        { bidder: "adform", params: { mid: "77661" } },
      ],
    },
    Iltalehti_Hyvaolo_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369398" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "347488" },
        },
        { bidder: "adform", params: { mid: "106669" } },
        { bidder: "adform", params: { mid: "116838" } },
      ],
    },
    Iltalehti_Hyvaolo_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651924" },
        },
        { bidder: "adform", params: { mid: "712124" } },
      ],
    },
    Iltalehti_Hyvaolo_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "154726" } },
        { bidder: "adform", params: { mid: "77660" } },
      ],
    },
    Iltalehti_ILTV_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "334442" } },
        { bidder: "adform", params: { mid: "101802" } },
      ],
    },
    Iltalehti_ILTV_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369364" },
        },
        { bidder: "adform", params: { mid: "116801" } },
      ],
    },
    Iltalehti_Matkailu_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "334506" } },
        { bidder: "adform", params: { mid: "101841" } },
      ],
    },
    Iltalehti_Matkailu_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "424712" } },
        { bidder: "adform", params: { mid: "171513" } },
      ],
    },
    Iltalehti_Matkailu_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369414" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369368" },
        },
        { bidder: "adform", params: { mid: "116800" } },
        { bidder: "adform", params: { mid: "116843" } },
      ],
    },
    Iltalehti_Matkailu_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651934" },
        },
        { bidder: "adform", params: { mid: "712130" } },
      ],
    },
    Iltalehti_Matkailu_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "424710" } },
        { bidder: "adform", params: { mid: "171514" } },
      ],
    },
    Iltalehti_Perhe_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "334508" } },
        { bidder: "adform", params: { mid: "101837" } },
      ],
    },
    Iltalehti_Perhe_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "348442" } },
        { bidder: "adform", params: { mid: "77637" } },
      ],
    },
    Iltalehti_Perhe_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "154730" } },
        { bidder: "adform", params: { mid: "77636" } },
      ],
    },
    Iltalehti_Perhe_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369412" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369366" },
        },
        { bidder: "adform", params: { mid: "116796" } },
        { bidder: "adform", params: { mid: "116841" } },
      ],
    },
    Iltalehti_Perhe_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651930" },
        },
        { bidder: "adform", params: { mid: "712132" } },
      ],
    },
    Iltalehti_Pippuri_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "237216" } },
        { bidder: "adform", params: { mid: "82468" } },
      ],
    },
    Iltalehti_Pippuri_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "154744" } },
        { bidder: "adform", params: { mid: "77648" } },
      ],
    },
    Iltalehti_Pippuri_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "154742" } },
        { bidder: "adform", params: { mid: "77647" } },
      ],
    },
    Iltalehti_Pippuri_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369406" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369130" },
        },
        { bidder: "adform", params: { mid: "116676" } },
        { bidder: "adform", params: { mid: "116842" } },
      ],
    },
    Iltalehti_Pippuri_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651932" },
        },
        { bidder: "adform", params: { mid: "712122" } },
      ],
    },
    Iltalehti_Saa_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "333172" } },
        { bidder: "adform", params: { mid: "101146" } },
      ],
    },
    Iltalehti_Saa_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "346172" } },
        { bidder: "adform", params: { mid: "106255" } },
      ],
    },
    Iltalehti_Saa_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369362" },
        },
        { bidder: "adform", params: { mid: "116802" } },
      ],
    },
    Iltalehti_Saa_Square_Middle_MobileWeb: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369410" },
        },
        { bidder: "adform", params: { mid: "116835" } },
      ],
    },
    Iltalehti_Terveys_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "334466" } },
        { bidder: "adform", params: { mid: "101832" } },
      ],
    },
    Iltalehti_Terveys_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "348442" } },
        { bidder: "adform", params: { mid: "77637" } },
      ],
    },
    Iltalehti_Terveys_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "154734" } },
        { bidder: "adform", params: { mid: "77652" } },
      ],
    },
    Iltalehti_Terveys_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369400" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "347490" },
        },
        { bidder: "adform", params: { mid: "106667" } },
        { bidder: "adform", params: { mid: "116836" } },
      ],
    },
    Iltalehti_Terveys_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651920" },
        },
        { bidder: "adform", params: { mid: "712127" } },
      ],
    },
    Iltalehti_Tyyli_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "334458" } },
        { bidder: "adform", params: { mid: "101816" } },
      ],
    },
    Iltalehti_Tyyli_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "348458" } },
        { bidder: "adform", params: { mid: "107518" } },
      ],
    },
    Iltalehti_Tyyli_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "407430" } },
        { bidder: "adform", params: { mid: "155781" } },
      ],
    },
    Iltalehti_Tyyli_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369402" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "347486" },
        },
        { bidder: "adform", params: { mid: "106653" } },
        { bidder: "adform", params: { mid: "116839" } },
      ],
    },
    Iltalehti_Tyyli_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651926" },
        },
        { bidder: "adform", params: { mid: "712125" } },
      ],
    },
    Iltalehti_Urheilu_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131288" } },
        { bidder: "adform", params: { mid: "77429" } },
      ],
    },
    Iltalehti_Urheilu_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131292" } },
        { bidder: "adform", params: { mid: "77425" } },
      ],
    },
    Iltalehti_Urheilu_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131294" } },
        { bidder: "adform", params: { mid: "77424" } },
      ],
    },
    Iltalehti_Urheilu_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369392" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "323676" },
        },
        { bidder: "adform", params: { mid: "98601" } },
        { bidder: "adform", params: { mid: "116833" } },
      ],
    },
    Iltalehti_Urheilu_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651912" },
        },
        { bidder: "adform", params: { mid: "712121" } },
      ],
    },
    Iltalehti_Uutiset_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131278" } },
        { bidder: "adform", params: { mid: "77418" } },
      ],
    },
    Iltalehti_Uutiset_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131282" } },
        { bidder: "adform", params: { mid: "77414" } },
      ],
    },
    Iltalehti_Uutiset_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131284" } },
        { bidder: "adform", params: { mid: "77413" } },
      ],
    },
    Iltalehti_Uutiset_ROS_MediumRectangle_Mobile_Top: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369390" },
        },
        { bidder: "adform", params: { mid: "98600" } },
      ],
    },
    Iltalehti_Uutiset_ROS_MediumRectangle_Mobile_Mid: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369390" },
        },
        { bidder: "adform", params: { mid: "116832" } },
      ],
    },
    Iltalehti_Uutiset_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651910" },
        },
        { bidder: "adform", params: { mid: "712120" } },
      ],
    },
    Iltalehti_Viihde_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131298" } },
        { bidder: "adform", params: { mid: "76207" } },
      ],
    },
    Iltalehti_Viihde_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131302" } },
        { bidder: "adform", params: { mid: "76208" } },
      ],
    },
    Iltalehti_Viihde_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "131304" } },
        { bidder: "adform", params: { mid: "76205" } },
      ],
    },
    Iltalehti_Viihde_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "369394" },
        },
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "323682" },
        },
        { bidder: "adform", params: { mid: "98602" } },
        { bidder: "adform", params: { mid: "116834" } },
      ],
    },
    Iltalehti_Viihde_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651914" },
        },
        { bidder: "adform", params: { mid: "712119" } },
      ],
    },
    Iltalehti_Raha_ROS_NordicParade: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "1406632" } },
        { bidder: "adform", params: { mid: "704295" } },
      ],
    },
    Iltalehti_Raha_ROS_MediumRectangle: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "1406618" } },
        { bidder: "rubicon", params: { zoneId: "1406630" } },
        { bidder: "adform", params: { mid: "704284" } },
        { bidder: "adform", params: { mid: "704292" } },
      ],
    },
    Iltalehti_Raha_ROS_WideSkyscraper: {
      bidders: [
        { bidder: "rubicon", params: { zoneId: "1406622" } },
        { bidder: "adform", params: { mid: "704289" } },
      ],
    },
    Iltalehti_Raha_ROS_MediumRectangle_Mobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "1406636" },
        },
        { bidder: "adform", params: { mid: "704311" } },
      ],
    },
    Iltalehti_Raha_Artikkeli_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "1406636" },
        },
        { bidder: "adform", params: { mid: "712128" } },
      ],
    },
    Iltalehti_Alapaikat_ROS_MediumRectangleMobile: {
      bidders: [
        {
          bidder: "rubicon",
          params: { siteId: "59724", zoneId: "651946" },
        },
        { bidder: "adform", params: { mid: "574681" } },
      ],
    },
  },
};

export default prebid;
